/**
 * Spreads list from yb360 core2 (wpcauth), not the Larry API base URL.
 */

import { getAuthApiUrl } from '@/config/config'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import type { Spread, SpreadAllResponse } from '@/api/types/spread'
import { logger } from '@/utils/logger'

const SPREADS_ALL_PATH = '/core2/spread/all'

export async function getSpreadsAll(): Promise<Spread[]> {
  const base = getAuthApiUrl().replace(/\/$/, '')
  const wpcauth = getWpcauthForExternalApi()

  if (!wpcauth) {
    throw new Error('Spreads list requires wpcauth session; please log in.')
  }

  const url = `${base}${SPREADS_ALL_PATH}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      wpcauth,
    },
  })

  if (!response.ok) {
    const text = await response.text().catch(() => '')

    throw new Error(
      `Spreads request failed: ${response.status} ${response.statusText}${text ? ` — ${text}` : ''}`
    )
  }

  const data = (await response.json()) as SpreadAllResponse

  if (!data?.result || !Array.isArray(data.payload?.spreads)) {
    logger.warn('Spreads API returned unexpected shape', { data })
    throw new Error('Spreads API returned invalid response')
  }

  return data.payload.spreads.filter((s): s is Spread => typeof s?.spreadId === 'string')
}
